document.addEventListener('DOMContentLoaded', function () {
  const pdps = document.querySelectorAll('.ab-pdp-v2');

  pdps.forEach(function (pdp) {
    const jsonEl = pdp.querySelector('.ab-pdp-v2__product-json');
    if (!jsonEl) return;

    const product = JSON.parse(jsonEl.textContent);
    const variantIdInput = pdp.querySelector('[data-variant-id-input]');
    const priceEl = pdp.querySelector('[data-price]');
    const compareEl = pdp.querySelector('[data-compare-price]');
    const discountBadge = pdp.querySelector('[data-discount-badge]');
    const stockWrap = pdp.querySelector('.ab-pdp-v2__stock');
    const stockText = pdp.querySelector('.ab-pdp-v2__stock-text');
    const addToCartBtn = pdp.querySelector('[data-add-to-cart]');
    const optionButtons = pdp.querySelectorAll('.ab-pdp-v2__option-btn');
    const qtyInput = pdp.querySelector('[data-qty-input]');
    const qtyMinus = pdp.querySelector('[data-qty-minus]');
    const qtyPlus = pdp.querySelector('[data-qty-plus]');
    const mainImage = pdp.querySelector('.ab-pdp-v2__main-image');
    const thumbRail = pdp.querySelector('[data-thumb-rail]');
    const thumbButtons = pdp.querySelectorAll('.ab-pdp-v2__thumb');
    const dotButtons = pdp.querySelectorAll('.ab-pdp-v2__dot');
    const prevBtn = pdp.querySelector('.ab-pdp-v2__arrow--prev');
    const nextBtn = pdp.querySelector('.ab-pdp-v2__arrow--next');
    const thumbUpBtn = pdp.querySelector('.ab-pdp-v2__thumb-nav--up');
    const thumbDownBtn = pdp.querySelector('.ab-pdp-v2__thumb-nav--down');

    const imageMedia = product.media.filter(function (m) {
      return m.media_type === 'image';
    });

    let selectedOptions = product.selected_or_first_available_variant
      ? [...product.selected_or_first_available_variant.options]
      : [...product.variants[0].options];

    let activeMediaId = product.selected_or_first_available_variant && product.selected_or_first_available_variant.featured_media
      ? product.selected_or_first_available_variant.featured_media.id
      : (imageMedia[0] ? imageMedia[0].id : null);

    function money(cents) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function findVariant(options) {
      return product.variants.find(function (variant) {
        return variant.options.every(function (opt, i) {
          return opt === options[i];
        });
      });
    }

    function anyVariantMatchesPartial(optionIndex, value) {
      if (optionIndex === 0) {
        return true;
      }

      const trial = [...selectedOptions];
      trial[optionIndex] = value;

      return product.variants.some(function (variant) {
        return variant.available && variant.options.every(function (opt, i) {
          if (i === optionIndex) return opt === value;
          if (i === 0) return opt === trial[0];
          if (i < optionIndex) return opt === trial[i];
          return true;
        });
      });
    }

    function getFirstAvailableVariantForSelection() {
      return product.variants.find(function (variant) {
        return variant.available && variant.options.every(function (opt, i) {
          return selectedOptions[i] === opt;
        });
      });
    }

    function getClosestAvailableVariant() {
      return product.variants.find(function (variant) {
        return variant.available && variant.options[0] === selectedOptions[0];
      }) || product.selected_or_first_available_variant || product.variants[0];
    }

    function normalizeSelectionAfterFirstOptionChange() {
      const exact = getFirstAvailableVariantForSelection();
      if (exact) return;

      const closest = getClosestAvailableVariant();
      if (!closest) return;

      selectedOptions = [...closest.options];
    }

    function updateThumbNavState() {
      if (!thumbRail || !thumbUpBtn || !thumbDownBtn) return;

      const atTop = thumbRail.scrollTop <= 2;
      const atBottom = thumbRail.scrollTop + thumbRail.clientHeight >= thumbRail.scrollHeight - 2;

      thumbUpBtn.classList.toggle('is-disabled', atTop);
      thumbDownBtn.classList.toggle('is-disabled', atBottom);
    }

    function scrollThumbIntoView(mediaId) {
      const activeThumb = pdp.querySelector('.ab-pdp-v2__thumb[data-media-id="' + mediaId + '"]');
      if (!activeThumb || !thumbRail) return;

      const railTop = thumbRail.scrollTop;
      const railBottom = railTop + thumbRail.clientHeight;
      const itemTop = activeThumb.offsetTop;
      const itemBottom = itemTop + activeThumb.offsetHeight;

      if (itemTop < railTop) {
        thumbRail.scrollTo({ top: itemTop - 10, behavior: 'smooth' });
      } else if (itemBottom > railBottom) {
        thumbRail.scrollTo({ top: itemBottom - thumbRail.clientHeight + 10, behavior: 'smooth' });
      }
    }

    function setActiveMedia(mediaId) {
      if (!mediaId) return;
      activeMediaId = mediaId;

      const media = imageMedia.find(function (m) {
        return Number(m.id) === Number(mediaId);
      });

      if (media && mainImage) {
        const src = media.preview_image && media.preview_image.src
          ? media.preview_image.src.replace(/(\.[a-z]+)(\?.*)?$/i, '_1800x$1')
          : media.src;

        if (src) {
          mainImage.src = src;
          mainImage.alt = media.alt || product.title;
        }
      }

      thumbButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', Number(btn.dataset.mediaId) === Number(mediaId));
      });

      dotButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', Number(btn.dataset.mediaId) === Number(mediaId));
      });

      scrollThumbIntoView(mediaId);
      updateThumbNavState();
    }

    function updateOptionAvailability() {
      optionButtons.forEach(function (btn) {
        const optionIndex = Number(btn.dataset.optionIndex);
        const value = btn.dataset.optionValue;
        const available = anyVariantMatchesPartial(optionIndex, value);

        btn.classList.toggle('is-unavailable', !available);

        if (selectedOptions[optionIndex] === value) {
          btn.classList.add('is-selected');
        } else {
          btn.classList.remove('is-selected');
        }
      });
    }

    function updateUIFromVariant() {
      const variant = findVariant(selectedOptions) || getClosestAvailableVariant() || product.selected_or_first_available_variant || product.variants[0];
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceEl) priceEl.textContent = money(variant.price);

      if (compareEl) {
        compareEl.textContent = variant.compare_at_price && variant.compare_at_price > variant.price
          ? money(variant.compare_at_price)
          : '';
      }

      if (discountBadge) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const savings = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          discountBadge.textContent = savings + '% OFF';
          discountBadge.classList.remove('is-hidden');
        } else {
          discountBadge.classList.add('is-hidden');
        }
      }

      if (stockWrap && stockText) {
        if (variant.available) {
          stockWrap.classList.remove('is-out-stock');
          stockWrap.classList.add('is-in-stock');
          stockText.textContent = 'In stock';
        } else {
          stockWrap.classList.remove('is-in-stock');
          stockWrap.classList.add('is-out-stock');
          stockText.textContent = 'Out of stock';
        }
      }

      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        addToCartBtn.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      }

      if (variant.featured_media && variant.featured_media.id) {
        setActiveMedia(variant.featured_media.id);
      }

      updateOptionAvailability();
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const optionIndex = Number(btn.dataset.optionIndex);
        const value = btn.dataset.optionValue;

        if (optionIndex !== 0 && btn.classList.contains('is-unavailable')) return;

        selectedOptions[optionIndex] = value;

        if (optionIndex === 0) {
          normalizeSelectionAfterFirstOptionChange();
        }

        updateUIFromVariant();
      });
    });

    thumbButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setActiveMedia(btn.dataset.mediaId);
      });
    });

    dotButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setActiveMedia(btn.dataset.mediaId);
      });
    });

    function currentMediaIndex() {
      return imageMedia.findIndex(function (m) {
        return Number(m.id) === Number(activeMediaId);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (!imageMedia.length) return;
        let idx = currentMediaIndex();
        idx = idx <= 0 ? imageMedia.length - 1 : idx - 1;
        setActiveMedia(imageMedia[idx].id);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!imageMedia.length) return;
        let idx = currentMediaIndex();
        idx = idx >= imageMedia.length - 1 ? 0 : idx + 1;
        setActiveMedia(imageMedia[idx].id);
      });
    }

    if (thumbUpBtn && thumbRail) {
      thumbUpBtn.addEventListener('click', function () {
        thumbRail.scrollBy({ top: -220, behavior: 'smooth' });
      });
    }

    if (thumbDownBtn && thumbRail) {
      thumbDownBtn.addEventListener('click', function () {
        thumbRail.scrollBy({ top: 220, behavior: 'smooth' });
      });
    }

    if (thumbRail) {
      thumbRail.addEventListener('scroll', updateThumbNavState);
      updateThumbNavState();
    }

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        const val = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = Math.max(1, val - 1);
      });
    }

    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        const val = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = val + 1;
      });
    }

    updateUIFromVariant();
  });
});